import { createInstance, ReactSDKClient } from '@optimizely/react-sdk';

let optimizely: ReactSDKClient | null = null;

export const getOptimizelyClient = (): ReactSDKClient => {
  if (!optimizely) {
    const isDev = /dev|stag/i.test(process.env.REACT_APP_ENV || '');
    optimizely = createInstance({
      sdkKey: process.env.REACT_APP_OPTIMIZELY_SDK_KEY,
      logLevel: isDev ? 'warning' : 'error',
      datafileOptions: {
        autoUpdate: true,
        updateInterval: isDev ? 1000 * 60 * 1 : 1000 * 60 * 5
      },
      eventBatchSize: 10,
      eventFlushInterval: 1000
    });
  }

  return optimizely;
};
